import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../../integrations/datadog/OctaneLogger'
import { defaultLosJsonHeaders } from '../../requestHeaders'

export interface LoginParams {
    username: string
    password: string
}

export default async function postLoginCredentials(
    params: LoginParams,
    returnSessionKey = false,
) {
    try {
        const response = await axios.post(
            `${config.API_BASE_URL}/api/v3/auth/sessions/login/`,
            params,
            {
                withCredentials: true,
                params: {
                    return_session_key: returnSessionKey ? '1' : undefined,
                },
                headers: defaultLosJsonHeaders(),
            },
        )

        return response
    } catch (error: unknown) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to post login credentials: ${axiosError.message}`,
            axiosError,
        )

        if (axiosError?.response) {
            return axiosError?.response
        }

        throw new Error(axiosError.message)
    }
}
